import { yupResolver } from "@hookform/resolvers/yup";
import { FilesUploader, If } from "components";
import { MediaDirectoryKeys, MediaType } from "constants/enums";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { t } from "i18next";
import { useForm, FormProvider, Resolver, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Button, FormField, LoaderScreen, MediaFilePicker } from "ui";

import { driverValidationSchema } from "../../../helpers";
import { useDriverDetailsFormSubmit, useDriversBasePath } from "../../../hooks";
import {
  DriverDetailsFormProps,
  DriverFormValues
} from "./DriverDetailsForm.types";
import {
  CertificatesBlock,
  MainInfoBlock,
  PriorityZonesBlock
} from "./FromBlocks";
import TrunkCapacityBlock from "./FromBlocks/TrunkCapacityBlock";

import styles from "./DriverDetailsForm.module.scss";

const DriverDetailsForm = ({ defaultValues }: DriverDetailsFormProps) => {
  const navigate = useNavigate();
  const basePath = useDriversBasePath();

  const formMethods = useForm<DriverFormValues>({
    defaultValues,
    resolver: yupResolver(driverValidationSchema) as Resolver<any, any>
  });

  const { control, handleSubmit } = formMethods;

  const { isSubmitLoading, onSubmit } =
    useDriverDetailsFormSubmit(defaultValues);

  const handleCancelClick = () => {
    navigate(basePath);
  };

  return (
    <FormProvider {...formMethods}>
      <form className={styles.driverForm} onSubmit={handleSubmit(onSubmit)}>
        <Controller
          control={control}
          name="image"
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <FormField
              label={t("Driver’s Photo")}
              errorMessage={error?.message}
            >
              <div className={styles.driverForm__imageBlock}>
                <FilesUploader
                  onSuccessUploading={onChange}
                  uploadDirectoryKey={MediaDirectoryKeys.InventoryManager}
                >
                  {(uploaderProps) => (
                    <MediaFilePicker
                      allowedMediaTypes={[MediaType.IMAGE]}
                      size="md"
                      variant="circle"
                      {...uploaderProps}
                      value={value}
                      onDeleteMediaFile={() => onChange(null)}
                      data-testid="driver--image"
                    />
                  )}
                </FilesUploader>
              </div>
            </FormField>
          )}
        />

        <div className={styles.driverForm__line} />

        <MainInfoBlock defaultValues={defaultValues} />

        <div className={styles.driverForm__line} />

        <CertificatesBlock defaultValues={defaultValues} />

        <div className={styles.driverForm__line} />

        <TrunkCapacityBlock />

        <div className={styles.driverForm__line} />

        <PriorityZonesBlock defaultValues={defaultValues} />

        <div className={styles.driverForm__line} />

        <div className={styles.driverForm__buttons}>
          <Button variant="default" onClick={handleCancelClick}>
            {t("Cancel")}
          </Button>
          <Button type="submit">{t("Submit")}</Button>
        </div>
      </form>

      <If condition={isSubmitLoading}>
        <LoaderScreen />
      </If>
    </FormProvider>
  );
};

export default DriverDetailsForm;
